import {ReactNode} from "react";

export const Quote = ({children, isRead}: {
  children: ReactNode,
  isRead?: boolean
}) => {
  let quoteClass = "p-2 flex gap-3 rounded-md ";
  let barClass = "vertical-line w-[5px] rounded-full flex-shrink-0 "
  if(isRead) {
    quoteClass += "bg-gray-11 text-gray-3 ";
    barClass += "bg-gray-6 "
  } else {
    quoteClass += "bg-[#F9F7F2] ";
    barClass += "bg-[#D4CFC3] "
  }
  return (<div className={quoteClass}>
    <div className={barClass}></div>
    <div>
      {children}
    </div>
  </div>)
}